var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"inner row"},[_c('span',{staticClass:"zzkicon-back",on:{"click":_vm.goBack}}),_c('p',{staticClass:"title clamp"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }